import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";

import { useTranslation } from "react-i18next";
import { startRegisterUserRoleModulesList } from "../../app/actions/userRoleModuleActions";
import { debugLogPages } from "../../app/helpers/debugHelper";
import { buildModuleCheckState } from "../../app/helpers/specialistRoleModuleHelper";

const CheckListComponentModules = ({ data, handleSaveRolesFromModules, catalogroleId = 2 }) => {
  debugLogPages(':: CheckListComponentModules'); 

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [checkedStateModules, setCheckedStateModules] = useState(data);
  const [notFoundData] = useState(false);
  const [nodesFiltered] = useState(data);

  const { listUserRoleModules } = useSelector((state) => state.userRoleModule);

  const { userInUserRole } = useSelector((state) => state.user);

  const updateCheckedValuesObject = () => {
    const updatedCheckedState = buildModuleCheckState(
      checkedStateModules,
      listUserRoleModules,
      catalogroleId
    );

    setCheckedStateModules(updatedCheckedState);
  };

  useEffect(() => {
    updateCheckedValuesObject();
  }, [listUserRoleModules, catalogroleId]);

  const handleOnChange = (id) => {
    const updatedCheckedState = checkedStateModules.map((item) =>
      item.id === id ? { ...item, value: !item.value } : item
    );

    setCheckedStateModules(updatedCheckedState);
  };

  const getCheckedStateById = (id) => {
    const checkedRow = checkedStateModules.find((ck) => ck.id === id);
    return checkedRow?.value;
  };

  const handleClickSaveModules = (e) => {
    e.preventDefault();

    handleSaveRolesFromModules();

    const arrayToSaveModules = [];

    checkedStateModules.forEach((element) => {
      if (element.value) {
        arrayToSaveModules.push({
          ...element,
          user_id: userInUserRole.id,
          catalogmodule_id: element.id,
          catalogrole_id: catalogroleId,
          deleted: !element.value,
        });
      }
    });

    if (Object.entries(userInUserRole).length === 0) {
      Swal.fire("Warning", "Select and user to continue", "warning");
    } else {
      dispatch(startRegisterUserRoleModulesList(arrayToSaveModules, userInUserRole.id));
      Swal.fire("success", "User Roles save succesfull", "success");
    }
  };

  return (
    <div>
      {notFoundData && <p className="help is-danger">Role not found</p>}

      <hr className="line-hr" />

      <ul className="list-group">
        {nodesFiltered.map(({ name, id }) => (
          <li key={id} className="list-group-item">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id={`custom-checkbox-module-${catalogroleId}-${id}`}
                name={name}
                value={name}
                checked={getCheckedStateById(id)}
                onChange={() => handleOnChange(id)}
              />
              <label className="form-check-label" htmlFor={`custom-checkbox-module-${catalogroleId}-${id}`}>
                {name}
              </label>
            </div>
          </li>
        ))}
      </ul>

      <hr className="line-hr" />

      <div className="d-flex justify-content-end">
        <button type="button" onClick={handleClickSaveModules} className="btn btn-primary">
          {t("buttons.submit")}
        </button>
      </div>
    </div>
  );
};

export default CheckListComponentModules;
